import { Box, Button, ResponsiveContext, Text } from "grommet";
import * as React from "react";
import { Route, Routes, useLocation, useMatches } from "react-router-dom";
import { usePermission, useUser } from "../account/AccountStore";
import BillingManagement from "../admin/BillingManagement";
import AliasesManagement from "../aliases/AliasesManagement";
import AppBar from "../AppBar";
import BadgesManagement from "../badges/BadgesManagement";
import CoachesManagement from "../coaches/CoachManagement";
import { useDarkMode } from "../components/DarkModeSwitch";
import SkeletonWrapper from "../components/SkeletonWrapper";
import ContentManagement from "../content/ContentManagement";
import DiscordServerManagement from "../discord/DiscordServerManagement";
import LeaguesManagement from "../leagues/LeaguesManagement";
import ManagementDashboard from "./ManagementDashboard";
import MatchesManagement from "../matches/MatchesManagement";
import SeasonsManagement from "../seasons/SeasonsManagement";
import SeedMatchesManagement from "../seeding/SeedMatchesManagement";
import StatsManagement from "../stats/StatsManagement";
import TeamsManagement from "../teams/TeamsManagement";
import TournamentsManagement from "../tournaments/TournamentsManagement";
import AdminHome from "../admin/AdminHome";
import ErrorBoundary from "../general/ErrorBoundary";
import GamesView from "../public/GamesView";
import MapsIndex from "../maps/MapsIndex";
import RegistrationHome from "../registration/RegistrationHome";

function Breadcrumbs() {
    let matches = useMatches();

    return (
        <ol>
            {matches?.map((crumb, index) => (
                <li key={index}>{crumb}</li>
            ))}
        </ol>
    );
}

const ManagementHome = () => {
    let user = useUser();

    React.useEffect(() => {
        if (user.isAuthenticated) {
            setLoading(false);
        }
        if (user.resolved && !user.isAuthenticated) {
            window.location.href = "/account/signin?redirectUrl=" + window.location.pathname;
        }
    }, [user]);

    const size = React.useContext(ResponsiveContext);
    const { pathname } = useLocation();
    const [pageSize, setPageSize] = React.useState(size == "small" ? "small" : "medium");

    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (pathname.indexOf("bracket") >= 0) {
            setPageSize("100%");
        } else {
            setPageSize(size == "small" ? "100%" : "80%");
        }
    }, [pathname]);

    const hasManagementPermission = usePermission("sport:management");

    const [isDarkMode] = useDarkMode();

    // background={{ image: isDarkMode ? "linear-gradient(135deg, rgba(253,138,138,0.1) 0%, rgba(168,209,170,0.1) 50%, rgba(0,212,255,0.1) 100%);" : "linear-gradient(135deg, rgba(253,138,138,0.2) 0%, rgba(168,209,170,0.2) 50%, rgba(0,212,255,0.2) 100%);" }}
    return (
        <SkeletonWrapper loading={loading} count={5}>
            <Box align={size != "small" ? "center" : ""}>
                {hasManagementPermission && (
                    <Box pad={{ left: "medium", right: "medium" }} width={pageSize} fill="vertical">
                        <AppBar></AppBar>
                        {/* <Breadcrumbs></Breadcrumbs> */}
                        {/* <Box pad={{ left: "medium", right: "medium" }} style={{ position: "relative", backgroundAttachment: "fixed", backgroundBlendMode: "darken" }} width={pageSize} background={{ image: isDarkMode ? "url(../images/background-black.jpg)" : "url(../images/background-white.jpg)" }} fill> */}
                        <ErrorBoundary>
                            <Routes>
                                <Route path="/" element={<ManagementDashboard />}></Route>
                                <Route path="/teams/*" element={<TeamsManagement />}></Route>
                                <Route path="/aliases/*" element={<AliasesManagement />}></Route>
                                <Route path="/games/" element={<GamesView />}></Route>
                                <Route path="/coaches/*" element={<CoachesManagement />}></Route>
                                <Route path="/matches/*" element={<MatchesManagement />}></Route>
                                <Route path="/tournaments/*" element={<TournamentsManagement />}></Route>
                                <Route path="/leagues/*" element={<LeaguesManagement />}></Route>
                                <Route path="/seasons/*" element={<SeasonsManagement />}></Route>
                                <Route path="/seedMatches/*" element={<SeedMatchesManagement />}></Route>
                                <Route path="/admin/*" element={<AdminHome />}></Route>
                                <Route path="/maps/*" element={<MapsIndex />}></Route>
                                <Route path="/registration/*" element={<RegistrationHome />}></Route>

                                {/* <Route path="/stats/*" element={<StatsManagement />}></Route>
                                <Route path="/billing/*" element={<BillingManagement />}></Route>
                                <Route path="/discord/*" element={<DiscordServerManagement />}></Route>
                                <Route path="/content/*" element={<ContentManagement />}></Route>
                                <Route path="/badges/*" element={<BadgesManagement />}></Route> */}
                            </Routes>
                        </ErrorBoundary>
                    </Box>
                )}
                {!hasManagementPermission && <Text>You do not have permissions to view this page</Text>}
            </Box>
        </SkeletonWrapper>
    );
};

export default ManagementHome;
